import React from "react";
import Modal from "react-modal";

export default function ConfirmModal({modalIsOpen, closeModal, approvedData, context, paymentData, props}) {

    const handleClose = function () {
        closeModal()
    }

    const proceedToBook = function () {
        props.history.push("/schedule/")
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Item added to cart"
            className="modal"
            overlayClassName="overlay"
            shouldCloseOnOverlayClick={false}
            appElement={document.getElementById("main")}
        >
            <div className="modal-container">
                <div className="modal-header">
                    <h2>Thank You!</h2>
                    <button className="button" onClick={handleClose}>
                        X
                    </button>
                </div>
            <div className="modal-contents">
                <div className="modal-message">
                    <p><span>Thank you for your payment of: $</span><span id="purchase-total">{paymentData.total}.00</span></p>
                    <p>Your transaction(<span>{`id: ${approvedData.orderID ?? "Processing..................."}`}</span>)<br/>has completed, and we are sending you<br/>an email receipt for your purchase.</p>
                    <p>{approvedData.approved && (<span>Please book your initial consultation or session now:</span>)}<br/></p>
                </div>
            </div>
            <div className="buttons">
                {approvedData.approved && (<button className="button" onClick={proceedToBook}>Book Now</button>)}
            </div>
        </div>
        </Modal>
        );
}